import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import "bootstrap/dist/css/bootstrap.min.css";
import './main.css';
import { env } from './env';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    env.VITE_DISABLE_STRICT === 'true' ? (<App />) : (<React.StrictMode>
        <App />
    </React.StrictMode>)
);